module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "runners"
  }, [_c('box', [(_vm.race.startDate !== null && _vm.race.finishDate === null) ? _c('box-header', {
    attrs: {
      "title": "TOP 3 RUNNERS"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.race.startDate !== null && _vm.race.finishDate === null) ? _c('box-content', [_c('top-three', {
    attrs: {
      "race-id": _vm.$route.params.raceId
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('box-header', {
    attrs: {
      "title": _vm.titleRunnersList
    }
  }), _vm._v(" "), _c('box-content', [_c('runners-list', {
    attrs: {
      "runners": _vm.runners
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00e4a36c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/Runners.vue
// module id = 1603
// module chunks = 2